<template>
  <div>
    <b-form-row>
      <b-col>
        <b-form-row>
          <label for="imageInput">Image</label>
          <b-form-group>
            
            <input
              v-validate="'validateImage|mimes:image/png,image/jpeg'"
              id="image-input"
              ref="imageInput"
              :class="{ 'is-invalid' : errors.has('image') }"
              type="file"
              accept="image/png,image/jpeg"
              name="image"
              @change="selectFile" />
            <validation-errors :validation-errors="[errors.first('image')]"/>
            <validation-errors v-if="!errors.has('image')" :validation-errors="apiErrors.file"/>

            <b-tooltip target="image-input" triggers="hover" placement="left">
              <div class="text-left form-group">
                <p class="rules-header">Image must be either a jpeg or png</p>
              </div>
            </b-tooltip>

          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group v-if="showCropImageButton">
            
            <b-button :disabled="saving" variant="outline-secondary" @click="$refs.imageCrop.openModal()">
              Crop Image
            </b-button>
          
          </b-form-group>
          <b-form-group v-if="cropImage">
            
            <b-button :disabled="saving" variant="outline-secondary" @click="revertImage()">
              Revert Image
            </b-button>
          
          </b-form-group>
        </b-form-row>
      </b-col>
      <b-col>
        <label for="imageInput">Preview</label>
        <b-form-group>
          <img :src="previewImage" class="crop-preview" height="150px" width="300px" />
        </b-form-group>
      </b-col>
    </b-form-row>

    <image-crop
      ref="imageCrop"
      :disabled="saving"
      :crop-width="Number(apiConfig.image.min_width)"
      :crop-height="Number(apiConfig.image.min_height)"
      :file-for-edit="fileForEdit"
      @cropped="setFile"
      @cropImage="setCropImage" />
  </div>
</template>

<script>

import imageCrop from './image-crop'
import { mapState } from 'vuex'
import validationErrors from './validation-errors'

export default {
  components: {
    imageCrop,
    validationErrors
  },    
  data() {
    return {
      show: true,
      typeSelection: null,
      typeOptions: [
        { text: 'Media Type', value: null },
        { text: 'Image', value: 'image' },
        { text: 'Video', value: 'video' },
        { text: 'PDF', value: 'pdf' }
      ],
      uneditedFile: null,
      fileForEdit: null,
      showCropImageButton: false,
      cropImage: false,
      previewImage: null
    }
  },
  computed: {
    ...mapState('media/forms/store', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    ...mapState('config', {
      apiConfig: 'data'
    }),
    errorAdded () {
      return this.errors.items
    }
  },
  watch: {
    errorAdded: function(){
      if (this.errors.has('image')) {
        this.$emit('imageUploadHasError', true)
      } else {
        this.$emit('imageUploadHasError', false)
      }
    }
  },
  methods: {
    setName (event) {
      this.$store.commit('media/forms/store/setField', {
        field: 'name',
        value: event
      })
    },
    selectFile (event) {
      const file = event.target.files[0]

      this.uneditedFile = file
      this.previewImage = null
      this.cropImage = false

      this.setFile (file)
    },
    setFile(file) {
      this.fileForEdit = file
      this.previewImage = URL.createObjectURL(file)
      this.showCropImageButton = true
      this.$emit('fileForEdit', this.fileForEdit)
      this.$emit('fileName', this.fileForEdit.name)
      this.$emit('cropImage', this.cropImage)
    },
    reset() {
      this.$refs.imageCrop.reset()
      this.fileForEdit = null
      this.cropImage = false
      this.uneditedFile = null
      this.showCropImageButton = false
      URL.revokeObjectURL(this.previewImage)
      this.previewImage = null
      this.errors.clear()
    },
    setCropImage (value) {
      this.cropImage = value
    },
    revertImage () {
      this.setFile(this.uneditedFile)
      this.cropImage = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/form/image-upload.vue